// extracted by css-extract-rspack-plugin
export default {"editSkillTable":"editSkillTable-wFL4s2","editSkillItemRow":"editSkillItemRow-l0Qre_","tagColumn":"tagColumn-D38zPJ"};